import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import storePersist from '../../../../../redux/storePersist';
import PageLoader from '../../../../../components/PageLoader';
import SocialProfilesComponent from '../components/social-profiles.component';
import { selectSocialProfilesQueryItems } from '../../../../../redux/social-profiles/selector';
import { socialProfiles } from '../../../../../redux/social-profiles/action';

const ManagementSocialProfile = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const socialProfilesQuery = useSelector(selectSocialProfilesQueryItems)
  const librariesItems = storePersist?.get("library")?.current;
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [ selectedSocialProfiles, setSelectedSocialProfiles ] = useState<any>([])

  const fetchSocialProfileQueryById= ()=>{
    dispatch(socialProfiles.query({
      url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles/query`,
      entity:'socialProfiles',
      jsonData:{
      Records: [
        {
          Id: parmas?.id
        }
      ]
    }})).then(()=>{
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedSocialProfiles({ ...selectedSocialProfiles, [field]: event })
  }

  useEffect(
    () => {
        
        if (parmas?.id > 0) {
            fetchSocialProfileQueryById()
            setIsLoading(false)
            } else{
                setIsLoading(false) 
            }
    },
    []
  )

  useEffect(() => {
        
      if (isQuery) {
        setSelectedSocialProfiles(socialProfilesQuery?.result?.items)
        }
    }, [isQuery]
  ) 

  const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
      if (parmas?.id > 0) {
        dispatch(socialProfiles.update({
          url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles`,
          entity:'socialProfiles',
          jsonData:{
            Records: [
                selectedSocialProfiles
            ]
        }})).then(()=>{ 
            back()
        })
      } else {
        dispatch(socialProfiles.create({
          url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles`,
          entity:'socialProfiles',
          jsonData:{
          Records: [
            selectedSocialProfiles
          ]
    }})).then(()=>{
        back()
      })
    }
  }
 
  const back=()=>{
    navigate('/management/cms/social-profiles')
  } 

  return (
      <>

      {isLoading ? <PageLoader /> : 
        <SocialProfilesComponent 
        handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          selectedSocialProfiles={selectedSocialProfiles}
          socialProfileType={librariesItems?.SocialProfileType}
        /> 
      } 
      </>
  )
    
  }
   
export default ManagementSocialProfile;